/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const instanceTypeMappingSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  defaultSourceState: z.string().nullish(),
  id: z.int(),
  integrationInstanceId: z.int(),
  itemTypeId: z.int(),
  organizationId: z.string(),
  sourceTypeId: z.string(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
